// Lien des publicités (gymnote.fr/app) : envoie vers le bon store selon le téléphone, sinon affiche les deux badges.
import React, { useEffect } from "react";
import Tiggy from "../site/Tiggy";
import BoutonsStores, { LIEN_APP_STORE, LIEN_GOOGLE_PLAY } from "../site/BoutonsStores";

// Les utm_* de la pub (ex. ?utm_source=meta&utm_campaign=surcharge&utm_content=pub-b) sont transmis à Google Play
// pour retrouver les installations dans la Play Console.
function parametresCampagne() {
	const recus = new URLSearchParams(window.location.search);
	const utm = {};
	["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach((cle) => {
		if (recus.get(cle)) utm[cle] = recus.get(cle);
	});
	return utm;
}

function lienGooglePlay(utm) {
	if (!Object.keys(utm).length) return LIEN_GOOGLE_PLAY;
	return `${LIEN_GOOGLE_PLAY}&referrer=${encodeURIComponent(new URLSearchParams(utm).toString())}`;
}

function lienDuStore() {
	const ua = navigator.userAgent || "";
	if (/android/i.test(ua)) return lienGooglePlay(parametresCampagne());
	// Les iPad récents se présentent comme un Mac, on les reconnaît à l'écran tactile.
	if (/iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return LIEN_APP_STORE;
	return null;
}

export default function TelechargerApp() {
	useEffect(() => {
		const lien = lienDuStore();
		if (lien) window.location.replace(lien);
	}, []);

	return (
		<section className="gs-page">
			<div className="gs-quadrillage gs-quadrillage--page" />
			<div className="gs-conteneur">
				<div className="gs-carte gs-page-carte">
					<Tiggy pose="pouce_leve" taille={150} />
					<h1 className="gs-page-titre">Télécharge GymNote</h1>
					<p className="gs-texte">Gratuit sur iPhone et Android.</p>
					<BoutonsStores />
				</div>
			</div>
		</section>
	);
}
